import React from "react";
import { validateNumber } from "../../helper/common";

const PricePositiveNagetive = ({
  value,
  isTextColor = true,
  onClick,
  isCursorPointer = false,
}) => {
  const colorStyle = isTextColor
    ? { color: validateNumber(value) >= 0 ? "green" : "red" }
    : isCursorPointer
    ? { cursor: "pointer" }
    : {};

  return (
    <div style={colorStyle} className="text-end" onClick={onClick}>
      {value}
    </div>
  );
};

export default PricePositiveNagetive;
